import { render, staticRenderFns } from "./IndicatorsIcon.vue?vue&type=template&id=5caa57a6&"
import script from "./IndicatorsIcon.vue?vue&type=script&lang=js&"
export * from "./IndicatorsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports